module.exports = __webpack_public_path__ + "static/img/europe-logo.5d6d18c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/europe-logo.png
// module id = oDej
// module chunks = 1